import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { lessonRoute } from '../lessons/lessons-routing.module';

import { LectureDetailComponent } from './lecture-detail/lecture-detail.component';
import { LectureEditComponent } from './lecture-edit/lecture-edit.component';
import { LectureLessonsComponent } from './lecture-lessons/lecture-lessons.component';
import { LectureSyllabusComponent } from './lecture-syllabus/lecture-syllabus.component';
import { LecturesComponent } from './lectures/lectures.component';
import { LectureResolver } from './shared/lecture-resolver.service';

export const lectureRoute = {
  path: ':id',
  component: LectureDetailComponent,
  resolve: {
    lecture: LectureResolver
  },
  children: [
    {
      path: '',
      redirectTo: 'lessons',
      pathMatch: 'full'
    },
    {
      path: 'edit',
      component: LectureEditComponent,
    },
    {
      path: 'lessons',
      component: LectureLessonsComponent,
      children: [
        {
          path: '',
          component: LectureSyllabusComponent
        },
        lessonRoute
      ]
    }
  ]
};

const routes: Routes = [
  {
    path: 'lectures',
    children: [
      {
        path: '',
        component: LecturesComponent
      },
      lectureRoute
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class LecturesRoutingModule { }



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lectures/lectures-routing.module.ts